import { load } from 'recaptcha-v3'

export async function getRecaptchaToken(siteKey) {
  const recaptcha = await load(siteKey, { autoHideBadge: true })
  return await recaptcha.execute('submit')
}
